import etherealBackgroundPoster from '../me_imgs/ethereal-background-poster.jpg';
import etherealBackgroundVideo from '../me_imgs/ethereal-background-optimized.mp4';
import chart1 from '../me_imgs/chart1.png';
import marketIntel5 from '../me_imgs/MarketIntel-5-display.jpg';
import reeltaOg from '../me_imgs/reelta-og.png';
import soulbeamHome from '../me_imgs/soulbeam-home.jpeg';
import storybookDiffusion from '../me_imgs/storybook-diffusion.jpeg';
import straitChokepoint from '../me_imgs/strait-chokepoint-display.jpg';

export const profile = {
  name: 'Liam Elia',
  intro: 'tinkerer.',
  aboutSections: [
    {
      label: 'Right now',
      value: 'Building side projects both digital and physical, currently working on a wood fire sauna.',
    },
    {
      label: 'Interests',
      value: 'Muay thai, hiking, travel, running, tech, reading.',
    },
    {
      label: 'Books',
      value: 'Children of Time (Tchaikovsky), The Wager (Grann), Neuromancer (Gibson), Dune (Herbert).',
    },
    {
      label: 'Recent recommendations',
      value: 'Hisense Touch Lite (e-ink reader), ULA Ultralight 40L backpack, Sony XM5 headphones.',
    },
  ],
};

export const entries = [
  {
    id: 'reelta',
    title: 'Reelta',
    meta: 'real estate video maker',
    menuNote: 'listing reels',
    tone: 'canyon',
    summary:
      'Turns listing photos into professional real estate videos automatically, without a videographer or a full shoot day.',
    detail: [
      'Built for agents who need to move from listing link to ready-to-post vertical reel quickly, with script, motion, voice, and delivery handled in one flow.',
      'The product is aimed at getting more showings with less coordination overhead, especially when speed matters more than setting up a custom video production process.',
    ],
    tags: ['Real estate', 'AI video', 'Listing reels', 'Automation'],
    links: [
      {
        label: 'reelta.ai',
        url: 'https://www.reelta.ai/',
      },
    ],
    media: [
      {
        src: reeltaOg,
        alt: 'Reelta preview showing automated real estate video generation.',
        aspectRatio: '1.7 / 1',
        fit: 'cover',
        position: 'center top',
      },
    ],
  },
  {
    id: 'market-intel',
    title: 'Market Intel',
    meta: 'multi-agent market research',
    menuNote: 'site research agents',
    tone: 'gold',
    summary:
      'A decision system for evaluating business locations using agents, structured inputs, and operational heuristics instead of generic reporting.',
    detail: [
      'Built a set of specialized agents to analyze pricing, reviews, hours, saturation, and market shape before turning them into one usable recommendation.',
      'The goal was not more dashboards. The goal was faster, repeatable research that could actually support a location decision.',
    ],
    tags: ['Python', 'CrewAI', 'Apify', 'Serper', 'Mapbox'],
    links: [],
    media: [
      {
        src: marketIntel5,
        alt: 'Market Intel map and analysis interface.',
        aspectRatio: '1.6 / 1',
        fit: 'cover',
        position: 'center center',
      },
    ],
  },
  {
    id: 'soulbeam',
    title: 'Soulbeam.ai',
    meta: 'voice interface and memory system',
    menuNote: 'voice memory',
    tone: 'dusk',
    summary:
      'A voice-first journal centered on realtime conversation, memory retrieval, and a more ambient relationship with recorded thought.',
    detail: [
      'The product combined speech interaction, retrieval, and a calmer interface so sessions could feel natural without losing continuity over time.',
      'Most of the engineering work went into making the system feel immediate while staying grounded in stored context and a usable product loop.',
    ],
    tags: ['OpenAI Realtime', 'WebRTC', 'Supabase', 'pgvector', 'Next.js'],
    links: [],
    media: [
      {
        src: soulbeamHome,
        alt: 'Soulbeam home experience with voice-first journaling interface.',
        aspectRatio: '1.6 / 1',
        fit: 'cover',
        position: 'center top',
      },
    ],
  },
  {
    id: 'strait-of-hormuz',
    title: 'Oil Tanker Passage Tracker',
    meta: 'data pipeline and monitoring',
    menuNote: 'shipping monitor',
    tone: 'ember',
    summary:
      'A monitoring tool for tanker traffic through a critical oil chokepoint, translated into structured signals instead of raw maritime noise.',
    detail: [
      'Built a Python pipeline to count vessel movement through a geofenced section of the Strait of Hormuz and compare those crossings against market context.',
      'The useful part was turning AIS data into something legible enough to inform actual thinking, not just collect logs.',
    ],
    tags: ['Python', 'AIS data', 'Pandas', 'Monitoring'],
    links: [],
    media: [
      {
        src: straitChokepoint,
        alt: 'Map view of a Strait of Hormuz shipping choke point.',
        aspectRatio: '1.28 / 1',
        fit: 'cover',
        position: 'center center',
      },
      {
        src: chart1,
        alt: 'Traffic and oil price graph for the Strait of Hormuz monitoring project.',
        aspectRatio: '1.55 / 1',
        fit: 'cover',
        position: 'center center',
      },
    ],
  },
  {
    id: 'storybook-generator',
    title: 'Storybook Generator',
    meta: 'genai illustration pipeline',
    menuNote: 'illustration pipeline',
    tone: 'petal',
    summary:
      'A workflow that turns prompts into printable storybooks with generated narrative, visual direction, and page assembly.',
    detail: [
      'Combined story generation, image workflows, and page output into one pipeline that could move from idea to finished artifact with minimal manual glue.',
      'The hard part was maintaining consistency across pages so the result felt authored instead of arbitrarily generated.',
    ],
    tags: ['Stable Diffusion', 'PyTorch', 'ComfyUI', 'PDF assembly'],
    links: [],
    media: [
      {
        src: storybookDiffusion,
        alt: 'Storybook Generator diffusion artwork preview.',
        aspectRatio: '1.45 / 1',
        fit: 'cover',
        position: 'center center',
      },
    ],
  },
];

export const writing = [];

export const contact = {
  linkedin: {
    label: 'linkedin.com/in/liam-elia',
    url: 'https://www.linkedin.com/in/liam-elia',
  },
};

export const heroLoop = {
  src: etherealBackgroundVideo,
  poster: etherealBackgroundPoster,
};

export const sections = [
  { id: 'about', label: 'About' },
  { id: 'projects', label: 'Projects' },
  ...(writing.length ? [{ id: 'writing', label: 'Writing' }] : []),
];
